import { IIconProps, P2GBox, P2GGrid, P2GIcon, P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

export type IconBulletItemProps = {
  content: ReactNode | string;
  icon: JSX.Element;
  iconPalette?: IIconProps['palette'];
  isBold?: boolean;
};

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(1)
  },
  content: {
    paddingLeft: theme.spacing(1)
  }
}));

export const IconBulletItem = ({ content, icon, iconPalette, isBold = true }: IconBulletItemProps): JSX.Element => {
  const { classes } = useStyles();

  return (
    <P2GGrid container className={classes.root}>
      <P2GGrid item>
        <P2GIcon size="xs" palette={iconPalette}>
          {icon}
        </P2GIcon>
      </P2GGrid>
      <P2GGrid item xs>
        {typeof content === 'string' ? (
          <P2GText component="p" fontWeight={isBold ? 'bold' : undefined} classNames={[classes.content]}>
            {content}
          </P2GText>
        ) : (
          <P2GBox classNames={classes.content}>{content}</P2GBox>
        )}
      </P2GGrid>
    </P2GGrid>
  );
};
